<template>
  <NotificationForm />
</template>

<script>
import NotificationForm from '@/layouts/components/form/NotificationForm.vue'
import store from '@/store'

export default {
  components: { NotificationForm },
  created() {
    store.commit('user/RESET_USER_LIST')
  },
}
</script>
